import React from 'react';
import moment from 'moment';

import {
  defaultDateFilters,
  updateDateRange,
  fetchFilterData,
  localstorageAvailable,
  isFilterExpired,
  isDesktopDevice
} from '../../../../services/services';
import { T } from '../../../../../../common/locale/translate';

import FlightAirport from '../../../../common/components/flight-airport';
import OfferType from './offer_type';
import Operators from '../../../../common/components/operators';
import Alimentation from './alimentation';
import Accommodations from '../../../../common/components/accommodations';
import DatePicker from '../../../../common/components/datepicker';
import TripLength from '../../../../common/components/trip-length';
import Adults from '../../../../common/components/adults';
import Children from '../../../../common/components/children';

export default class SearchForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      url: '',
      default_offer_type: 'A',
      duration: { default: {}, values: [] },
      filterDataCacheTime: 259200000,
      active: false,
      alimentations: [],
      startDate: props.params.departure_date || defaultDateFilters().from,
      endDate: props.params.return_date || defaultDateFilters().to,
      activeIndex: 0,
      params: {
        ...props.params
      },
      default_activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        hotel_name: true
      },
      activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        hotel_name: true
      }
    };
    this.state.durationMin = this.state.params
      ? this.state.params.duration_min
      : 7;
    this.state.returnDateRangeStart = moment
      .unix(this.state.startDate)
      .add(this.state.durationMin, 'days');
  }

  componentDidMount() {
    this.setInitialData();
  }

  render() {
    return (
      <section className="search-form wrapper">
        <div className="mobile-action-wrapper">
          <button onClick={this.handleMobileToggle} className="search-button">
            {T('filter_results')}{' '}
            <i className="fa fa-search" aria-hidden="true" />{' '}
          </button>
        </div>
        <div
          className={`search-form-outside-wrapper ${
            this.state.active ? 'active' : ''
          }`}
        >
          <div className="mobile-header-wrapper">
            <h3 className="mobile-header">
              {' '}
              {T('filter_results')}{' '}
              <i
                className="fa fa-times mobile-toggle-switch"
                aria-hidden="true"
                onClick={this.handleMobileToggle}
              />{' '}
            </h3>
          </div>
          <div className="search-form-inside-wrapper">
            <div className="search">
              <div className="search-wrapper">
                <div className="row-wrapper">
                  <FlightAirport
                    title={T('departure_from')}
                    ref="departure_airports"
                    filter_active={this.state.activity.departure_airports}
                    departure_airports={this.state.params.departure_airports}
                    marginOffset={45}
                  />
                  <OfferType
                    title={T('type')}
                    ref="offer_type"
                    offer_type={this.state.params.offer_type}
                    marginOffset={45}
                  />
                  <Operators
                    title={T('operator')}
                    ref="operators"
                    operators={this.state.params.operator_code}
                    marginOffset={45}
                  />
                  <Alimentation
                    title={T('board')}
                    ref="boards"
                    boards={this.state.params.boards}
                    alimentations={this.state.alimentations}
                    marginOffset={45}
                  />
                </div>
                <div className="row-wrapper">
                  <DatePicker
                    title={T('travel_departure')}
                    ref="departure_date"
                    className="date-from"
                    onChange={this.updateDates.bind(this, 'startDate')}
                    date={this.state.startDate}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    name="departure_date"
                    selectsStart
                    withPortal={!isDesktopDevice()}
                  />

                  <DatePicker
                    title={T('travel_arrival')}
                    ref="return_date"
                    className="date-to"
                    onChange={this.updateDates.bind(this, 'endDate')}
                    date={this.state.endDate}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    name="return_date"
                    selectsEnd
                    withPortal={!isDesktopDevice()}
                    minDate={this.state.returnDateRangeStart}
                  />
                  <TripLength
                    title={T('travel_time_period')}
                    ref="duration"
                    filter_active={this.state.activity.duration}
                    duration_min={this.state.params.duration_min}
                    duration_max={this.state.params.duration_max}
                    duration={this.state.duration}
                    marginOffset={45}
                    on_change_duration={this.updateDuration.bind(this)}
                  />
                  <Adults
                    title={T('adults_number')}
                    ref="adults_number"
                    adults_number={this.state.params.adults_number}
                    marginOffset={45}
                  />
                  <Children
                    title={T('children_number')}
                    ref="children_ages"
                    children_ages={this.state.params.children_ages}
                    marginOffset={45}
                  />
                  <Accommodations
                    title={T('accommodation')}
                    ref="accommodations"
                    boards={this.state.params.accommodations}
                    accommodations={this.state.accommodations}
                    marginOffset={45}
                  />
                </div>
              </div>
              <div className="action-wrapper">
                <button onClick={this.handleSearch} className="search-button">
                  <i className="fa fa-search" /> {T('look_for')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  setInitialData() {
    if (localstorageAvailable()) {
      if (isFilterExpired('default', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('default_filter'));
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      }
    } else {
      this.updateFilterSource();
    }
  }

  updateFilterSource = () => {
    fetchFilterData('default_filter').then(
      response => {
        const filter_data = response.data;
        if (localstorageAvailable()) {
          localStorage.setItem('default_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'default_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      },
      error => {
        console.log('Error when fetching default filter', error);
      }
    );
  };

  changeActivityStates = offer_type => {
    const activities = {
      A: {
        ...this.state.default_activity
      },
      S: {
        ...this.state.default_activity,
        departure_airports: false
      },
      C1: {
        ...this.state.default_activity,
        duration: false,
        hotel_name: false
      },
      C2: {
        ...this.state.default_activity,
        hotel_name: false
      },
      C: {
        ...this.state.default_activity,
        hotel_name: false
      }
    };
    this.setState({ activity: activities[offer_type] });
  };

  handleTabChange = (type, index) => {
    this.setState({ default_offer_type: type, activeIndex: index });
    this.changeActivityStates(type);
  };

  updateDates = (name, date) => {
    this.setState(
      updateDateRange(name, date, {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      }),
      () =>
        this.setState({
          returnDateRangeStart: moment
            .unix(this.state.startDate)
            .add(this.state.durationMin, 'days')
        })
    );
  };

  updateDuration = duration => {
    this.setState({
      durationMin: duration.min,
      returnDateRangeStart: moment
        .unix(this.state.startDate)
        .add(duration.min, 'days')
    });
  };

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
    }
    this.setState({ active: !this.state.active });
  };

  handleSearch = () => {
    let temp = {},
      key,
      value;
    Object.keys(this.refs).map(v => {
      key = v;
      value = this.refs[v].returnSearchedValue();
      if (value) {
        switch (key) {
          case 'duration': {
            temp['duration_min'] = value.min;
            temp['duration_max'] = value.max;
            break;
          }
          case 'offer_type': {
            if (value !== 'C') {
              temp['offer_type'] = value;
            } else {
              temp['offer_type'] = 'C2';
            }
            break;
          }
          case 'flight_type': {
            temp['offer_type'] = value;
            break;
          }
          default: {
            temp[key] = value;
          }
        }
      }
      temp['offer_type'] = temp['offer_type'] ? temp['offer_type'] : 'A';
    });

    this.props.search(temp);
    this.setState({ active: false });
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_variants/search.js